/**
 * Team — the People module, opened on the people who run this academy.
 *
 * Team and Learners were two pages over one dataset. They are one module now
 * (`admin/people/AdminPeople`), because the same person is routinely both: an
 * instructor enrolled in a colleague's course belongs on both lists, and two screens
 * that each own half of that answer disagree about who they are.
 *
 * This file survives as the sidebar's entry point and nothing else — the preset picks
 * the tab, and the filter above the list moves between them without leaving the page.
 */

import AdminPeople from '../people/AdminPeople';

export default function AdminTeam() {
  return <AdminPeople preset="team" />;
}
